<template>
  <div>
    <v-app-bar class="white main-header-mobile" app>
      <div class="py-2 d-flex align-end">
        <router-link class="d-flex" to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="navbar-brand"
          />
        </router-link>
      </div>

      <v-spacer />

      <v-app-bar-nav-icon
        color="secondary"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer class="white" v-model="drawer" fixed temporary>
      <div class="px-8 py-6 d-flex flex-column">
        <router-link to="/" class="d-flex">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="mx-auto navbar-brand"
          />
        </router-link>
      </div>

      <v-list-item-group v-model="current">
        <v-list>
          <div v-for="({ text, to }, i) in menu" :key="i">
            <v-list-item v-if="to" :to="to" link>
              <v-list-item-content>
                <v-list-item-title
                  class="primary--text text-body-1 font-weight-regular nav-link"
                >
                  {{ text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list>
      </v-list-item-group>
    </v-navigation-drawer>
  </div>
</template>

<script>
export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    informations() {
      if (!this.$rest("informations").item) return "";
      return this.$rest("informations").item;
    },
  },
  data() {
    return {
      current: this.$route.path,
      drawer: false,
    };
  },
};
</script>

<style scoped>
.nav-link .icon {
  vertical-align: baseline;
}
</style>

<style>
.main-header-mobile {
  box-shadow: 0px 4px 8px rgba(133, 136, 140, 0.12) !important;
}

.main-header-mobile .navbar-brand {
  height: 42px;
}

.v-navigation-drawer__content .navbar-brand {
  height: 70px;
}

.v-navigation-drawer {
  z-index: 630 !important;
}

.v-list-item__icon .v-icon {
  color: #ffffff !important;
  font-size: 14px !important;
}
</style>
